export { default as IconBlob } from './IconBlob'
export { IconBlobSize, IconBlobType } from './types'
export type { IconBlobComponentType, IconBlobProps } from './types'
